@if (!isLoading) {
  <div class="tag-container">
    @for (tag of tags; track tag.id) {
      <div
        class="tag"
        [ngClass]="{ selected: isSelected(tag) }"
        (click)="toggleTag(tag)">
        <span class="font-bold-label-large">{{ tag.name }}</span>
      </div>
    }
  </div>
}

@if (isLoading) {
  <div class="tag-container">
    <p-skeleton borderRadius="8px" height="32px" width="168px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="104px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="71px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="89px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="208px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="195px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="190px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="173px"></p-skeleton>
    <p-skeleton borderRadius="8px" height="32px" width="45px"></p-skeleton>
  </div>
}
